import {
    apiRequest,
    pencantumanGelarExportUsulan,
} from "../../../../../services/adapters/kepegawaian/pencantumanGelarService"

class IndexRepository {

    fetchExportUsulan = async (query) => {
        return await apiRequest("get", pencantumanGelarExportUsulan, {
            params: query
        }, true)
    }
}

export default IndexRepository